export enum CrossSellingRoutes {
    Edit = '/:crossSellingId/edit',
    New = '/new',
    List = '/',
}
